import React, { useMemo } from "react";

import { Dispatcher } from "../../../../../../../../../../services";
import { useAppContext } from "../../../../../../../../../../context";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const BirthAtCellContent: React.FC<BirthAtCellContent.Props> = ({ item }) => {
	const { dateFns } = useAppContext();
	const content = useMemo(
		() =>
			item.birthAt
				? dateFns.formatTime2(item.birthAt, "dd.MM.yyyy") ?? ""
				: "",
		[dateFns, item.birthAt],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace BirthAtCellContent {
	interface Props {
		item: Dispatcher.Model;
	}
}

export default BirthAtCellContent;
